import { LawsuitListPage } from "@pages/LawsuitListPage";
import { LawsuitPage } from "@pages/LawsuitPage";
import { NewsPage } from "@pages/NewsPage";
import { PaymentsPage } from "@pages/PaymentsPage";
import { ProfilePage } from "@pages/ProfilePage";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const ClientAccessRoute = () => {
  return (
    <Switch>
      <Route path="/profile">
        <ProfilePage />
      </Route>
      <Route path="/lawsuits" exact>
        <LawsuitListPage />
      </Route>
      <Route path="/lawsuit/:lawsuitId/:tab?">
        <LawsuitPage />
      </Route>
      <Route path="/payments">
        <PaymentsPage />
      </Route>
      <Route path="/news">
        <NewsPage />
      </Route>
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};

export default ClientAccessRoute;
